// @ts-nocheck
import React from 'react';
import routes from 'configs/routes';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import NotFound from 'pages/NotFound';
import Home from 'pages/Home';

const switchRoutes = [
  {
    path: routes.dashboard,
    component: Home
  }
];

function App() {
  return (
    <BrowserRouter>
      <Switch>
        {switchRoutes.map((route, index) => {
          return (
            <Route key={index} exact path={route.path}>
              <route.component />
            </Route>
          );
        })}
        <Route path="*" component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
